import React from 'react';
import styles from './ModalFormField.module.css';
import { FCWithChildren } from '../../../utility/utility.types';

const ModalFormField: FCWithChildren = ({ children }) => {
    return <div className={styles.field}>{children}</div>;
};

export default ModalFormField;
